<div class="cobra-login-header">
    Aanmelden via FAS
</div>
<div class="cobra-login-buttons">
    <cevi-login imgPath="dist/assets/images/eid.svg" loginText="FAS EID" (onClick)="doFasEid()"></cevi-login>
    <cevi-login imgPath="dist/assets/images/itsme.svg" loginText="FAS ItsMe" (onClick)="doFasItsme()"></cevi-login>
</div>
<div class="cobra-login-header">
    Azure Active Directory
</div>
<div class="cobra-login-buttons">
    <cevi-login imgPath="dist/assets/images/azure-ad.svg" loginText="Azure AD" (onClick)="doAad()"></cevi-login>
</div>
